module.exports = __webpack_public_path__ + "img/ignis-glx-azul-sodalita.decbcde6.png";